(() => {
  const score = hand => {
    let total = 0, aces = 0;
    for (const card of hand) { total += card.rank === 'A' ? 11 : Math.min(10, Number(card.rank) || 10); if (card.rank === 'A') aces++; }
    while (total > 21 && aces-- > 0) total -= 10;
    return total;
  };
  const outcome = (player, dealer) => {
    const p = score(player), d = score(dealer);
    if (p > 21) return 'bust';
    const pn = p === 21 && player.length === 2, dn = d === 21 && dealer.length === 2;
    if (pn && !dn) return 'blackjack';
    if (dn && !pn) return 'lose';
    if (p === d) return 'tie';
    return d > 21 || p > d ? 'win' : 'lose';
  };
  const deck = () => ['♠','♥','♣','♦'].flatMap(suit => ['A','2','3','4','5','6','7','8','9','10','J','Q','K'].map(rank => ({rank,suit})));
  const random = n => { const a = new Uint32Array(1), max = 4294967296 - 4294967296 % n; do { crypto.getRandomValues(a); } while(a[0] >= max); return a[0] % n; };
  const shuffle = cards => { for (let i = cards.length - 1; i > 0; i--) { const j = random(i + 1); [cards[i],cards[j]] = [cards[j],cards[i]]; } return cards; };
  if (typeof module !== 'undefined') module.exports = {score,outcome,deck,shuffle};
  if (typeof document === 'undefined') return;
  const dialog = document.getElementById('n5x-blackjack');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const launcher = document.getElementById('n5x-bj-launcher');
  const syncLauncher = () => { launcher.hidden = dialog.open; launcher.setAttribute('aria-expanded', String(dialog.open)); };
  const t = JSON.parse(dialog.querySelector('[data-bj-text]').textContent);
  const q = s => dialog.querySelector(s);
  const testing = new URLSearchParams(location.search).get('n5x_blackjack_test') === '1';
  const key = 'n5x_blackjack_draft_v1';
  let autoOpenTimer;
  const visitKey = 'n5x_blackjack_auto_shown_v1';
  let autoShown = false;
  try { autoShown = sessionStorage.getItem(visitKey) === '1'; } catch {}
  const rememberShown = () => {
    autoShown = true;
    clearTimeout(autoOpenTimer);
    try { sessionStorage.setItem(visitKey, '1'); } catch {}
  };
  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; } };
  const save = value => { if (!testing) try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  let state = testing ? {} : read(), cards, player, dealer, finished = false, dealerTurn = false, revealed = false, turnVersion = 0;
  const rewards = [{code:'N5XSPIN5',label:'five'},{code:'N5XSPIN5',label:'five'},{code:'N5XSPIN5',label:'five'},{code:'N5XSPIN10',label:'ten'},{code:'N5XSPIN25',label:'twentyfive'},{code:'N5XSPIN50',label:'fifty'}];
  const renderHand = (who, hand) => {
    const container = q('[data-hand="'+who+'"]');
    hand.forEach((card,i) => {
      const hidden = who === 'dealer' && i === 1 && !revealed;
      const signature = hidden ? 'back' : card.rank + card.suit;
      const previous = container.children[i];
      if (previous && previous.dataset.card === signature) return;
      const el = document.createElement('span');
      el.dataset.card = signature;
      el.className = 'n5x-bj-card' + (hidden ? ' back' : ['♥','♦'].includes(card.suit) ? ' red' : '');
      el.setAttribute('aria-label', hidden ? t.hidden : card.rank + ' ' + card.suit);
      if (hidden) el.textContent = 'N5X';
      else { const rank = document.createElement('span'), suit = document.createElement('i'); rank.textContent = card.rank; suit.textContent = card.suit; el.append(rank,suit); }
      if (previous) previous.replaceWith(el); else container.append(el);
    });
    q('[data-total="'+who+'"]').textContent = who === 'dealer' && !revealed ? score([hand[0]]) + ' + ?' : score(hand);
  };
  const render = () => { renderHand('player',player); renderHand('dealer',dealer); };
  const finish = () => {
    if (finished) return;
    finished = true;
    q('[data-action="hit"]').disabled = true; q('[data-action="stand"]').disabled = true;
    render();
    q('.n5x-bj-actions').hidden = true; q('.n5x-bj-rules').hidden = true;
    q('[data-result]').textContent = t[outcome(player,dealer)];
    const reward = rewards[state.reward];
    q('[data-reward]').textContent = t[reward.label];
    q('[data-code]').textContent = testing ? 'TEST-NOT-REDEEMABLE' : reward.code;
    q('.n5x-bj-result').hidden = false;
    state.completed = true; save(state);
    q('.n5x-bj-result').focus({preventScroll:true});
    q('.n5x-bj-result').scrollIntoView({block:'nearest',behavior:'instant'});
  };
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  const stand = async (draw = true, initialDelay = 450) => {
    if (finished || dealerTurn) return;
    dealerTurn = true;
    const version = ++turnVersion;
    const active = () => version === turnVersion && dialog.open;
    q('[data-action="hit"]').disabled = true;
    q('[data-action="stand"]').disabled = true;
    await pause(initialDelay);
    if (!active()) return;
    const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hiddenCard = q('[data-hand="dealer"]').children[1];
    if (motion) hiddenCard.animate([{transform:'rotateY(0deg)'},{transform:'rotateY(90deg)'}], {duration:280,fill:'forwards',easing:'ease-in'});
    await pause(280);
    if (!active()) return;
    revealed = true;
    renderHand('dealer',dealer);
    if (motion) q('[data-hand="dealer"]').children[1].animate([{transform:'rotateY(-90deg)'},{transform:'rotateY(0deg)'}], {duration:320,easing:'ease-out'});
    await pause(1300);
    if (!active()) return;
    while (draw && score(dealer) < 17) {
      dealer.push(cards.pop());
      renderHand('dealer',dealer);
      await pause(1200);
      if (!active()) return;
    }
    await pause(700);
    if (active()) finish();
  };
  q('[data-action="hit"]').addEventListener('click', () => { if (finished || dealerTurn) return; player.push(cards.pop()); renderHand('player',player); if (score(player) > 21) stand(false, 900); else if (score(player) === 21) stand(); });
  q('[data-action="stand"]').addEventListener('click',()=>stand());
  q('[data-action="copy"]').addEventListener('click',async () => { try { await navigator.clipboard.writeText(q('[data-code]').textContent); q('[data-action="copy"]').textContent = t.copied; } catch { const range=document.createRange();range.selectNodeContents(q('[data-code]')); const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range); } });
  const close = () => {turnVersion++;rememberShown();dialog.close();syncLauncher();launcher.focus({preventScroll:true});};
  q('.n5x-bj-close').addEventListener('click',close); q('[data-action="shop"]').addEventListener('click',close);
  dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
  const deal = () => {
    turnVersion++;
    finished = false; dealerTurn = false; revealed = false;
    q('[data-hand="dealer"]').replaceChildren();
    q('[data-hand="player"]').replaceChildren();
    q('.n5x-bj-result').hidden = true;
    q('.n5x-bj-actions').hidden = false;
    q('.n5x-bj-rules').hidden = false;
    q('[data-action="hit"]').disabled = false;
    q('[data-action="stand"]').disabled = false;
    q('[data-action="copy"]').textContent = t.copy;
    q('#n5x-bj-intro').textContent = state.completed ? t.replay_note : t.intro;
    cards=shuffle(deck());player=[cards.pop(),cards.pop()];dealer=[cards.pop(),cards.pop()];
    render();
    dialog.scrollTop = 0;
    q('[data-action="hit"]').focus({preventScroll:true});
    if(score(player)===21||score(dealer)===21) stand(false, 1800);
  };
  q('[data-action="replay"]').addEventListener('click', () => { if (finished) deal(); });
  const open = () => {
    if (dialog.open) return;
    if (!testing) state=read();
    rememberShown();
    if (!Number.isInteger(state.reward) || !rewards[state.reward]) state.reward = random(rewards.length);
    save(state);
    q('[data-test]').hidden = !testing;
    dialog.showModal();syncLauncher();deal();
  };
  launcher.addEventListener('click',open);
  syncLauncher();
  if (!autoShown) autoOpenTimer = setTimeout(() => {
    if (autoShown || document.querySelector('mobile-navigation[open], cart-drawer[open], .drawer[open], dialog[open]')) return;
    open();
  },10000);
})();


